import * as React from "react"
import { StaticImage } from "gatsby-plugin-image"

import Layout from "../components/layout"
import SEO from "../components/seo"

import Row from "../components/themableUI/row"
import Col from "../components/themableUI/col"

const AboutPage = () => (
  <Layout>
    <SEO title="About" />
    <h2 style={{ display: "none" }}>About</h2>
    <Row>
      <Col
        size={12}
        sizes={{ md: 6 }}
        style={{ paddingLeft: "0", display: "flex", justifyContent: "center" }}
      >
        <StaticImage
          src="../images/about.jpg"
          width={600}
          quality={95}
          formats={["AUTO", "WEBP", "AVIF"]}
          alt="the blogger"
        />
      </Col>
      <Col size={12} sizes={{ md: 6 }}>
        <p>
          Lorem ipsum dolor sit, amet consectetur adipisicing elit. Magnam
          dolorem in, repellendus deserunt qui esse error ullam est dolorum
          harum!
        </p>
        <p>
          Lorem ipsum dolor sit amet consectetur adipisicing elit. Labore iure,
          asperiores magni doloribus delectus voluptas quidem maiores earum
          libero quas autem molestias cupiditate voluptate assumenda ab porro.
          Veritatis, adipisci expedita! Voluptatem quam ullam et eligendi.
        </p>
      </Col>
    </Row>
  </Layout>
)

export default AboutPage
